import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { TProviderUser, TProviderUserResponse, adaptProviderUserFromResponse } from '../../types';
import { BACKEND_ADMIN_PROVIDER_USER } from '../../backend-paths';


export const providerUserReadGetApi = createAsyncThunk(
	`FETCH/${BACKEND_ADMIN_PROVIDER_USER}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_ADMIN_PROVIDER_USER}/${payload}`;

		return HttpService.get<TProviderUserResponse>(path).then(result => {
			return adaptProviderUserFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TProviderUser> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const providerUserReadSlice = createSlice({
	name: 'providerUserReadSlice',
	initialState,
	reducers: {
		setProviderUserRead(state, action: PayloadAction<TProviderUser>) {
			state.item = action.payload;
		},

		clearProviderUserRead(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[providerUserReadGetApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[providerUserReadGetApi.fulfilled.type]: (state, action: PayloadAction<TProviderUser>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[providerUserReadGetApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useProviderUserReadSelector = () => useAppSelector(state => state[providerUserReadSlice.name]);

export const { clearProviderUserRead, setProviderUserRead } = providerUserReadSlice.actions;
